var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ion-item',{style:(_vm.style),attrs:{"button":""},on:{"click":_vm.onClick}},[_c('db-img',{attrs:{"slot":"start","icon":"","name":_vm.iconName},slot:"start"}),_c('ion-label',[_vm._v(_vm._s(_vm.label))]),(_vm.badge)?_c('ion-badge',[_vm._v(" "+_vm._s(_vm.badge)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }